import DOMPurify from 'dompurify'

import styles from './styles.module.scss'

export const sanitizeWithLinks = (html: string) => {
  const sanitized = DOMPurify.sanitize(html, {
    ADD_ATTR: ['target', 'class'],
  })

  const doc = new DOMParser().parseFromString(sanitized, 'text/html')

  doc.querySelectorAll('a').forEach((anchor) => {
    anchor.setAttribute('target', '_blank')
    anchor.classList.add(styles.link)
  })

  return doc.body.innerHTML
}
